import React, { useState, useEffect } from 'react';

import { DatePicker, Select, Radio } from 'antd';
import {
  HomeOutlined,
  FileDoneOutlined,
  SearchOutlined,
  CaretUpOutlined, DeleteOutlined, DownOutlined, CaretDownOutlined, PlusCircleOutlined, CheckOutlined, UpOutlined
} from '@ant-design/icons';
import {default as Order} from './order';
import {default as Delivery} from './delivery';
import {default as Goods} from './goods';
import {default as Buyer} from './buyer';
import './style';

export default React.forwardRef((props, ref) => {
  const [selectedType, setSelectedType] = useState(0);
  useEffect(() => {

  }, []);
  const handleTypeChange = (e) => {
    setSelectedType(e.target.value);
  }

  return (
    <div style={{ padding: '1rem 1.5rem' }}  >
      <div className="stat-header">
        <strong>请选择分析分类：</strong>
        <Radio.Group onChange={handleTypeChange} value={selectedType}>
          <Radio value={0}>订单量</Radio>
          <Radio disabled value={1}>价格</Radio>
          <Radio disabled value={2}>供应商</Radio>
          <Radio disabled value={3}>产品</Radio>
          <Radio value={4}>客户（开发中）</Radio>
        </Radio.Group>
        <Select></Select>
      </div>
      {selectedType === 0 && <Order />}
      {selectedType === 1 && <Goods />}
      {selectedType === 2 && <Delivery />}
      {selectedType === 4 && <Buyer />}
    </div>
  )
});
